(function ($) {
    var UIPhotoUploader = (function ($) {

        UIPhotoUploader = function (options) {
            var that = this;

            that.options = options || {};

            // CONST
            that.selectors = {
                photo_uploader_wrapper: '.js-photo-uploader-wrapper',
                photo_uploader: '.js-photo-uploader',
                photo_upload_container: '.js-photo-upload-container',
                input_file: '.js-input-file',
                edit_buttons: '.js-edit-buttons',
                edit_button_zoom_in: '.js-edit-button-zoom-in',
                edit_button_zoom_out: '.js-edit-button-zoom-out',
                uploaded_image: '.js-uploaded-image',
                photo_preview_wrapper: '.js-photo-preview-wrapper',
            };
            that.locales = that.options['locales'] || {};
            that.photo = that.options['photo'] || {};
            that.photo_max_filesize = that.options['photo_max_filesize'] || 5;
            that.image_allowed_extensions = that.options['image_allowed_extensions'] || ['jpg', 'jpeg', 'png', 'gif'];

            // DOM
            that.$wrapper = that.options['wrapper'] || $.sa.$document.find(that.selectors.photo_uploader_wrapper);
            that.$body = $('body');
            that.$photo_upload_container = that.$wrapper.find(that.selectors.photo_upload_container);
            that.$photo_uploader = that.$wrapper.find(that.selectors.photo_uploader);
            that.$input_file = that.$wrapper.find(that.selectors.input_file);
            that.$edit_buttons = that.$wrapper.find(that.selectors.edit_buttons);
            that.$uploaded_file_name = that.$wrapper.find('.js-uploaded-file-name');
            that.$uploaded_image = that.$wrapper.find(that.selectors.uploaded_image);

            // Data from cropper
            that.attached_file = { };

            // HANDLERS
            that.onCropperReady = (that.options['onCropperReady'] || function () {});
            that.onError = (that.options['onError'] || function () {});

            // INIT
            that.init();
        };
    
        UIPhotoUploader.prototype.init = function () {
            var that = this;

            if (that.photo.full_size.length > 0) {
                that.prepareSelector(that.photo.full_size);
            } else {
                that.$wrapper.find(that.selectors.photo_preview_wrapper + ' img').attr('src', that.photo.small_size);
            }

            that.initEventHandlers();
        };
    
        UIPhotoUploader.prototype.initEventHandlers = function () {
            var that = this;

            that.$body.on('dragover.UserPhotoEdit drop.UserPhotoEdit', $.proxy(that.preventSystemDnd, that));
            that.$photo_upload_container.on('dragover.UserPhotoEdit drop.UserPhotoEdit', $.proxy(that.preventSystemDnd, that));

            that.$photo_upload_container.on('dragenter.UserPhotoEdit', $.proxy(that.__highlight, that));
            that.$photo_upload_container.on('dragleave.UserPhotoEdit, drop.UserPhotoEdit', $.proxy(that.__unhighlight, that));
            that.$photo_upload_container.on('drop.UserPhotoEdit', $.proxy(that.handleDrop, that));

            that.$photo_upload_container.find(that.selectors.input_file).on('change', $.proxy(that.replaceImage, that));
        };

        UIPhotoUploader.prototype.replaceImage = function() {
            var that = this;

            var file = that.$input_file[0].files[0];

            if (!that.$input_file[0].files.length || !that.$input_file[0].files[0]) {
                return;
            }

            this.fileSelected(file);
        };
    
        UIPhotoUploader.prototype.handleDrop = function(e) {
            try {
                var file = e.originalEvent.dataTransfer.files[0];
                if (file) {
                    this.fileSelected(file);
                }
            } catch (error) {
                var result = that.onError(that, file, 'handle_drop');
            }
        };

        UIPhotoUploader.prototype.preventSystemDnd = function(e) {
            e.preventDefault();
        };

        UIPhotoUploader.prototype.fileSelected = function(file) {
            var that = this;

            if (!that.__isValidFile(file)) {
                return;
            }
    
            // Read file contents as data url, then show in $image_img
            that.attached_file = file;
    
            this.$uploaded_file_name.text(file.name).removeClass('hidden');
    
            var reader = new FileReader();
    
            reader.onload = function(event) {
                that.prepareSelector(event.target.result);
            }
    
            reader.onerror = function() {
                return;
            }
    
            reader.readAsDataURL(file);
        };
    
        UIPhotoUploader.prototype.prepareSelector = function(img_src) {
            var that = this;
    
            if (!$.fn.cropper) {
                return;
            }
    
            that.$uploaded_image.parent().removeClass('hidden');
            that.$uploaded_image[0].src = img_src;
            that.$edit_buttons.removeClass('hidden');
    
            that.$uploaded_image.on('load', function() {
                that.$uploaded_image.cropper('destroy');
    
                var crop_data = {};
    
                that.$uploaded_image.cropper({
                    dragMode: 'move',
                    viewMode: 1,
                    preview: that.selectors.photo_preview_wrapper,
                    guides: false,
                    cropBoxResizable: false,
                    minCropBoxWidth: 120,
                    minCropBoxHeight: 120,
                    ready: function(event) {
                        that.$edit_buttons.find(that.selectors.edit_button_zoom_in).on('click', () => {
                            this.cropper.zoom(0.1);
                        });
                        
                        that.$edit_buttons.find(that.selectors.edit_button_zoom_out).on('click', () => {
                            this.cropper.zoom(-0.1);
                        });
    
                        var source_width = event.target.width;
                        var source_height = event.target.height;
    
                        var pos_x = source_width > source_height ? Math.abs((source_width / 2) - (source_height / 2) + (source_height * 0.1)) : Math.abs(source_width * 0.1);
                        var pos_y = source_width > source_height ? Math.abs(source_height * 0.1) : Math.abs((source_height / 2) - (source_width / 2) + (source_width * 0.1));
    
                        var target_square = source_width > source_height ? Math.abs(source_height * 0.8) : Math.abs(source_width * 0.8);

                        crop_data = {
                            x: pos_x,
                            y: pos_y,
                            width: target_square,
                            height: target_square
                        };
    
                        this.cropper.setData(crop_data);

                        var result = that.onCropperReady(that);
                    },
                    data: crop_data
                });
            });
        };

        /**
         * 
         * @returns {formData}
         */
        UIPhotoUploader.prototype.getFormData = function() {
            var that = this,
                cropper = that.$uploaded_image.data('cropper'),
                crop_data = cropper.getData(),
                form_data = new FormData();

            form_data.append('ww', that.$uploaded_image[0].width);
            form_data.append('x1', crop_data.x);
            form_data.append('y1', crop_data.y);
            form_data.append('x2', crop_data.x + crop_data.width);
            form_data.append('y2', crop_data.y + crop_data.height);
            form_data.append('w', crop_data.width);
            form_data.append('h', crop_data.height);

            var has_no_attached_file = $.isEmptyObject(that.attached_file);
            if (has_no_attached_file) {
                form_data.append('edit_area', '1');
            } else {
                form_data.append('photo', that.attached_file);
            }

            return form_data;
        };

        /**
         * @returns {boolean}
         * @private
         */
        UIPhotoUploader.prototype.__isValidFile = function(file) {
            var that = this,
                regex_string = '^image\\/(' + that.image_allowed_extensions.join('|') + ')$',
                regex = new RegExp(regex_string),
                is_valid = true;

            if (!file.type.match(regex)) {
                var result = that.onError(that, file, 'wrong_extension');
                if (false === result) {
                    return false;
                }
            }
            if (file.size > that.__getMaxFilesizeInBytes()) {
                var result = that.onError(that, file, 'size_exceeded');
                if (false === result) {
                    return false;
                }
            }
            
            return is_valid;
        };

        /**
         * @returns {number}
         * @private
         */
        UIPhotoUploader.prototype.__getMaxFilesizeInBytes = function() {
            var that = this;

            return that.photo_max_filesize * 1024 * 1024;
        };

        /**
         * @private
         */
        UIPhotoUploader.prototype.__highlight = function() {
            var that = this;

            that.$photo_uploader.addClass('highlight');
        };

        /**
         * @private
         */
        UIPhotoUploader.prototype.__unhighlight = function(e) {
            var that = this;

            if ( e.currentTarget.contains(e.relatedTarget) ) {
                return;
            }

            that.$photo_uploader.removeClass('highlight');
        };
    
        return UIPhotoUploader;
    })($);

    $.uiPhotoUploader = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);

        return new UIPhotoUploader(options);
    };
})(jQuery);
